module.exports = __webpack_public_path__ + "img/16-green.c4f6c21b.svg";